module.exports = __webpack_public_path__ + "img/box-lofi.cae9d206.png";